import React from 'react'
import {Container, Row, Col} from 'react-bootstrap'
import './style.css'
import Tombol from 'components/componentsmall/button'

export default function jumbotron() {
    return (
         <Container className="container-jumbotron">
            <Row>
                <Col md={6} sm={6} xs={12}>
                    <h3 className="home-judul">
                        Kata-kata menarik untuk calon user agar mau daftar 
                    </h3>
                    <div className="jumbo-content">
                        <p>Kata-kata menarik kedua untuk calon user, disini agak lebih ditonjolkan <span>1 Point</span> penting yang bisa menarik minat calon user.</p>
                        <Tombol to="/daftar" tombol="Mulai Jualan Sekarang"/>
                    </div> 
                    <div className="jumb-small">Kata-kata pendorong untuk user, biasanya tidak terlalu dibaca, jadi kemungkinan kata katanya lebih ke dorongan mendaftar untuk klik link diatas.</div> 
                </Col>
                <Col md={6} sm={6} xs={12} className="img-jumbotron">
                    <img src="asset/home/jumb_img.png" alt="jumbotron" />
                </Col>
             </Row>
         </Container>
    )
}
